// @ts-nocheck
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  container: {
    width: "100%",
    padding: 50,
  },
  pageTitle: {
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  title: {
    fontFamily: "rokh",
    textAlign: "right",
    fontSize: 20,
    marginTop: 10,
    fontWeight: 900,
  },
  subtitle: {
    textAlign: "right",
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 20,
  },
  scoreWrapper: {
    width: "100%",
    borderRadius: 15,
    padding: 20,
    marginBottom: 20,
    borderWidth: 1,
    backgroundColor: "#DDE3FF",
    flexDirection: "row-reverse",
    alignItems: "center",
    justifyContent: "space-between",
  },
  scoreWrapperText: {
    width: "80%",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  scoreTitle: {
    fontFamily: "rokh",
    fontSize: 20,
    fontWeight: 900,
    color: "#000",
    marginTop: 6,
  },
  scoreTitleInfo: {
    fontFamily: "rokh",
    fontSize: 15,
    fontWeight: 700,
    color: "#000",
    marginTop: 1,
    textAlign: "right",
  },
  scoreValueWrapper: {
    flexDirection: "row-reverse",
  },
  scoreValue: {
    fontFamily: "rokh",
    fontSize: 25,
    fontWeight: 900,
    color: "#000",
    marginTop: 5,
  },
  panels: {
    gap: 5,
    flexWrap: "wrap",
    flexDirection: "row-reverse",
    backgroundColor: "#fff",
  },
  normalPanel: {
    padding: 15,
    backgroundColor: "#ECFEDB",
    flexDirection: "column",
    alignItems: "flex-start",
    width: "24.3%",
    borderRadius: 10,
  },
  abnormalPanel: {
    padding: 15,
    backgroundColor: "#cdefff",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "24.3%",
    borderRadius: 10,
  },
  panelTitleWrapper: {
    flexDirection: "row-reverse",
    justifyContent: "space-between",
    width: "100%",
  },
  panelInfo: {
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  panelTitle: {
    textAlign: "right",
    fontSize: 13,
    fontWeight: "bold",
  },
  goodStatus: {
    color: "green",
    fontWeight: 900,
    fontSize: 14,
    fontFamily: "rokh",
    marginTop: 6,
  },
  badStatus: {
    color: "red",
    fontWeight: 900,
    fontSize: 14,
    fontFamily: "rokh",
    marginTop: 6,
  },
  panelValue: {
    textAlign: "right",
    fontSize: 18,
    marginTop: 5,
    fontWeight: "bold",
  },
  notPro: {
    padding: 15,
    backgroundColor: "#FFF1B8",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "75%",
  },
  notProText: {
    fontWeight: 900,
    fontSize: 14,
    fontFamily: "rokh",
    marginTop: 6,
    textAlign: "right",
  },
});

const isResultNormal = (result) => {
  if (result.status === "N") return true;

  const range = result.component.range[0];
  if (!range) return true;

  const value = result.result_value;
  const lowNormal = range.low_normal;
  const highNormal = range.high_normal;

  if (lowNormal !== null && highNormal !== null) {
    return value >= lowNormal && value <= highNormal;
  } else if (lowNormal !== null) {
    return value >= lowNormal;
  } else if (highNormal !== null) {
    return value <= highNormal;
  }

  return true;
};

const PdfTestPanels = ({ testResults, is_pro }: any) => {
  const healthScore = testResults?.general_score;

  return (
    <View style={styles.container}>
      <View style={styles.pageTitle}>
        <Text style={styles.title}>تحلیل اختصاصی آزمایش پزشکی</Text>
        <Text style={styles.subtitle}>
          هر دسته از فاکتورهای آزمایش شما وضعیت سلامتی شما رو توی یه بخش بررسی
          می‌کنه، توی این صفحه چک کن که کدوم موارد برای تو توی وضعیت نرمال قرار
          داره و کدوم موارد نیاز به بررسی بیشتر داره
        </Text>
      </View>

      <View style={styles.scoreWrapper}>
        <View style={styles.scoreWrapperText}>
          <Text style={styles.scoreTitle}> :امتیاز سلامتی شما </Text>
          {!is_pro && (
            <Text style={styles.scoreTitleInfo}>
              اگه تحلیل پیشرفته رو انتخاب کنی، ما می‌تونیم به وضعیت سلامتیت یه
              امتیاز بدیم که با توجه به اون شرایط خودت رو بسنجی
            </Text>
          )}
        </View>
        <View style={styles.scoreValueWrapper}>
          <Text style={styles.scoreValue}>{is_pro ? healthScore : "-"}</Text>
          <Text style={styles.scoreValue}>از 100 </Text>
        </View>
      </View>

      <View style={styles.panels}>
        {testResults?.panel_advice &&
          Object.entries(testResults?.panel_advice)
            .slice(
              0,
              is_pro ? Object.entries(testResults.panel_advice).length : 1
            )
            .map(([testName, data]: any, idx) => {
              const totalItems = data.total_count;
              const abnormalItems = data.unnormal_component_name.length;
              let isGood = true;
              if (totalItems === 1) {
                isGood = abnormalItems === 0;
              } else {
                isGood = abnormalItems <= 2;
              }

              return (
                <View
                  key={testName}
                  style={isGood ? styles.normalPanel : styles.abnormalPanel}
                >
                  <View style={styles.panelTitleWrapper}>
                    <View style={styles.panelInfo}>
                      <Text style={styles.panelTitle}>{testName}</Text>
                      <Text style={styles.panelValue}>
                        {data.normal_count}/{data.total_count}
                      </Text>
                    </View>
                    <Text style={isGood ? styles.goodStatus : styles.badStatus}>
                      {isGood ? "نرمال" : "نیازمند بررسی"}
                    </Text>
                  </View>
                </View>
              );
            })}
        {!is_pro && (
          <View style={styles.notPro}>
            <Text style={styles.notProText}>
              برای دیدن بقیه موارد، تحلیل پیشرفته آزمایش رو انتخاب کنید
            </Text>
          </View>
        )}
      </View>
    </View>
  );
};

export default PdfTestPanels;
